export const ALLOWANCE_TYPES = {
  MEDICAL_CERTIFICATE: 1,
  JUSTIFIED_ABSENCE: 2,
  VACATION: 3,
};
